// ブランド表記（略称 + 正式名称）の並び。
//
// 認証系の 6 画面（ログイン / 登録 / パスワード再設定要求・確定 / パスワード変更 /
// 初回ヒアリング）に同じ markup が複製されていたものを 1 箇所にまとめたもの。
// 文字列だけでなく**見た目の定義もここが正本**なので、ブランド表記を変えるときは
// このファイルだけを見ればよい。
import { brand } from "../lib/brand";

export function BrandLockup({
  /**
   * 画面幅で大きくしない小さめの表記。
   * パスワード変更画面は右側に戻るリンクが並ぶため、元から小さい方を使っている。
   */
  compact = false,
}: {
  compact?: boolean;
} = {}) {
  // 略称と正式名称が同じブランド（例: 「オフレコ」）で 2 回並べると
  // 「オフレコ オフレコ」になる。同じなら 1 つだけ出す。
  const hasSeparateShortName = brand.shortName !== brand.name;
  return (
    <span className="flex items-baseline gap-2" aria-label={brand.name}>
      <span
        className={`${
          compact ? "text-2xl" : "text-2xl md:text-3xl"
        } font-extrabold tracking-wider text-tora-accent leading-none`}
        style={{ fontFamily: "'Noto Serif JP', 'Times New Roman', serif" }}
      >
        {brand.shortName}
      </span>
      {hasSeparateShortName && (
        <span
          className={`${
            compact ? "text-sm" : "text-sm md:text-base"
          } font-semibold tracking-wide text-tora-ink`}
        >
          {brand.name}
        </span>
      )}
    </span>
  );
}
